/*
 * Some configuration, from the v2 palette, for components which are based on the v2 component library.
 */

export const theme = {
  colors: {
    primary: {
      black: '#0F1821',
    },
    flag: {
      informative: 'rgba(59, 108, 241, 0.1)',
    },
  },
};
